export const pictureMotion = {
	initial: 'init',
	whileInView: 'inView',
	variants: {
		init: () => ({
			opacity: 0,
		}),
		inView: {
			opacity: 1,
		},
	},
	transition: {
		type: 'tween',
		duration: 0.8,
		ease: 'easeOut',
	},
	viewport: {
		once: true,
		amount: 0.3,
	},
};
